export const ScrimBasic = ({ enabled = false, onClick }) => (
  <div
    onClick={onClick}
    className={`${
      enabled ? "absolute" : "hidden"
    } bg-black bg-opacity-20 top-0 bottom-0 right-0 left-0 w-screen h-screen z-70`}
  ></div>
);
